<div class="card">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <label class="card-title fw-semibold">
      Additional GHS Representative #{{number}}
      <span class="material-symbols-outlined" style="color: green;">eco</span>
    </label>

    <div class="d-inline-flex align-items-center">
      <span class="material-symbols-outlined" style="color: red; cursor: pointer;"
            (click)="delete.emit()">delete</span>
    </div>
  </div>
  <div class="container">
    <div class="row g-2">
      <div class="col-6">
        <label>Name:</label>
      </div>
      <div class="col-6">
        <label>Email:</label>
      </div>

      <div class="col-6">
        <select class="form-select" [(ngModel)]="name" (ngModelChange)="nameChange.emit($event)">
          <option value="" disabled selected hidden>Select Teacher</option>
          <option *ngFor="let teacher of teacherList" [value]="teacher.fullName">
            {{ teacher.fullName }}
          </option>
        </select>
      </div>
      <div class="col-6">
        <input type="text" class="form-control" [value]="email || 'Select a GHS Rep'" readonly>
      </div>
    </div>
  </div>


</div>
<br>

